/* Community block (snippets/nw-community.liquid). Loads when the block is near the screen. */
(() => {
  const API = "https://community.northwoofs.com";
  const box = document.querySelector("[data-nwc]");
  if (!box) return;
  const IG = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1.1" class="f"/></svg>';
  const esc = s => String(s || "").replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const len = d => Math.floor(d / 60) + ":" + String(d % 60).padStart(2, "0");

  function render(posts) {
    const two = box.querySelector(".nwc-two");
    /* one or two posts sit side by side; from three on they become a swipe row with the next card peeking in */
    two.classList.toggle("nwc-swipe", posts.length > 2);
    two.innerHTML = posts.slice(0, 5).map(p => {
      const media = p.type === "video"
        ? `<video muted playsinline loop preload="none" poster="${esc(p.poster)}" data-src="${esc(p.src)}" aria-label="${window.NWT.fmt(window.NWT.community.reel_by, { user: esc(p.user) })}"></video>${p.dur ? `<span class="nwc-len">${len(p.dur)}</span>` : ""}`
        : `<img src="${esc(p.src)}" alt="${window.NWT.fmt(window.NWT.community.photo_by, { user: esc(p.user) })}" loading="lazy" decoding="async"><span class="nwc-ig">${IG}</span>`;
      return `<a class="nwc-c" href="${esc(p.link)}" target="_blank" rel="noopener" data-id="${esc(p.id || "")}">${media}<span class="nwc-u">@${esc(p.user)}</span></a>`;
    }).join("");
    box.hidden = false;
    arrows(two);
    /* count taps per post (no cookies, nothing about the shopper): shows in the picker which posts interest people */
    two.addEventListener("click", e => {
      const a = e.target.closest(".nwc-c");
      if (!a || !a.dataset.id) return;
      const body = JSON.stringify({ h: box.dataset.nwc, id: a.dataset.id });
      try { navigator.sendBeacon(API + "/t", body); } catch (err) {}
    });
    const vids = two.querySelectorAll("video");
    if (!vids.length) return;
    const still = matchMedia("(prefers-reduced-motion: reduce)").matches;
    const io = new IntersectionObserver(es => es.forEach(e => {
      const v = e.target;
      if (e.isIntersecting && e.intersectionRatio >= 0.5 && !still) {
        if (!v.src) v.src = v.dataset.src;
        v.muted = true; v.play().catch(() => {});
      } else v.pause();
    }), { threshold: [0, 0.5] });
    vids.forEach(v => {
      io.observe(v);
      /* the length badge counts down while the reel plays, and starts over when it loops */
      const pill = v.parentNode.querySelector(".nwc-len");
      if (pill) v.addEventListener("timeupdate", () => { if (v.duration) pill.textContent = len(Math.max(0, Math.ceil(v.duration - v.currentTime))); });
    });
  }

  /* desktop: the same round arrows as the product photos, so the row can be browsed without swiping; the mouse can also drag it */
  function arrows(two) {
    const prev = box.querySelector("[data-nwc-prev]"), next = box.querySelector("[data-nwc-next]");
    if (!prev || !two.classList.contains("nwc-swipe")) return;
    const step = () => { const c = two.querySelector(".nwc-c"); return c ? c.offsetWidth + 8 : 200; };
    const update = () => { prev.hidden = two.scrollLeft < 4; next.hidden = two.scrollLeft + two.clientWidth >= two.scrollWidth - 4; };
    prev.onclick = () => two.scrollBy({ left: -step(), behavior: "smooth" });
    next.onclick = () => two.scrollBy({ left: step(), behavior: "smooth" });
    two.addEventListener("scroll", update, { passive: true });
    addEventListener("resize", update);
    update();
    let down = null, moved = false;
    two.addEventListener("mousedown", e => { if (e.button) return; down = { x: e.clientX, s: two.scrollLeft }; moved = false; e.preventDefault(); });
    addEventListener("mousemove", e => { if (!down) return; const dx = e.clientX - down.x; if (Math.abs(dx) > 4) { moved = true; two.classList.add("nwc-drag"); } two.scrollLeft = down.s - dx; });
    addEventListener("mouseup", () => { if (!down) return; down = null; two.classList.remove("nwc-drag"); });
    /* a drag isn't a click on the card underneath */
    two.addEventListener("click", e => { if (moved) { e.preventDefault(); e.stopImmediatePropagation(); moved = false; } }, true);
  }

  function load() {
    fetch(`${API}/p/${encodeURIComponent(box.dataset.nwc)}.json`)
      .then(r => r.ok ? r.json() : { posts: [] })
      .then(j => { if (j.posts && j.posts.length) render(j.posts); })
      .catch(() => {});
  }

  if (!("IntersectionObserver" in window)) return load();
  const near = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { near.disconnect(); load(); } }, { rootMargin: "800px 0px" });
  /* the block is hidden (display: none) until it has posts, and hidden elements never report being on screen, so watch its parent */
  near.observe(box.parentElement);
})();
